<div class="local-storage-manager-container no-select">

  <div class="lsm-container-heading">
    <div class="title">FEATURE <span>/</span> LOCAL STORAGE <span>/</span>
      <div class="text-global">MANAGER</div>
    </div>
  </div>

  <div class="widget-div">

    @if (canStorageBeViewed) {
      <app-shared-widget-container-component class="expanded">
        <div title class="widget-div-heading">
          <app-display-icon
            [tooltip]="canStorageBeCleared ? tooltips.editAccessGranted : tooltips.editAccessDenied"
            [icon]="canStorageBeCleared ? icons.lockOpenOutline : icons.lockClosedOutline">
          </app-display-icon>
          <div>Local Storage Summary</div>
        </div>
        <div block>
          <div class="storage-summary">
            <div class="summary-item">
              <div class="summary-label">Total Items:</div>
              <div class="summary-value">{{ getTotalCount() }}</div>
            </div>
            <div class="summary-item">
              <div class="summary-label">Items with Values:</div>
              <div class="summary-value">{{ getItemCount() }}</div>
            </div>
            <div class="summary-item">
              <div class="summary-label">Categories:</div>
              <div class="summary-value">{{ categories().length }}</div>
            </div>
          </div>
        </div>
        <div actions class="widget-actions">
          @if (canStorageBeCleared) {
            <button
              type="button"
              class="action-button"
              (click)="onClearAll()">
              <app-display-icon
                [colour]="iconColours.red"
                [tooltip]="'Clear All Storage'"
                [icon]="icons.deleteOutline">
              </app-display-icon>
            </button>
          }
        </div>
      </app-shared-widget-container-component>

      @for (category of categories(); track category.name) {
        <app-shared-widget-container-component>
          <div title class="widget-div-heading">
            <app-display-icon
              [tooltip]="canStorageBeCleared ? tooltips.editAccessGranted : tooltips.editAccessDenied"
              [icon]="canStorageBeCleared ? icons.lockOpenOutline : icons.lockClosedOutline">
            </app-display-icon>
            <div>{{ category.displayName }}</div>
            <div class="category-count">({{ category.items.length }} items)</div>
          </div>
          <div block>
            <div class="storage-items">
              @for (item of category.items; track item.key) {
                <div class="storage-item" [class.has-value]="hasValue(item)">
                  <div class="item-info">
                    <div class="item-name">{{ item.displayName }}</div>
                    <div class="item-key">{{ item.key }}</div>
                    @if (hasValue(item)) {
                      <div class="item-value">{{ item.value }}</div>
                    } @else {
                      <div class="item-value empty">No value</div>
                    }
                  </div>
                  <div class="item-actions">
                    @if (canStorageBeCleared && hasValue(item)) {
                      <button
                        type="button"
                        class="clear-button"
                        (click)="onClearItem(item)">
                        <app-display-icon
                          [colour]="iconColours.secondary"
                          [tooltip]="'Clear Item'"
                          [icon]="icons.closeCircleOutline">
                        </app-display-icon>
                      </button>
                    }
                  </div>
                </div>
              }
            </div>
          </div>
          <div actions class="widget-actions">
            @if (canStorageBeCleared) {
              <button
                type="button"
                class="action-button"
                (click)="onClearCategory(category)">
                <app-display-icon
                  [colour]="iconColours.red"
                  [tooltip]="'Clear Category'"
                  [icon]="icons.deleteOutline">
                </app-display-icon>
              </button>
            }
          </div>
        </app-shared-widget-container-component>
      }
    }

  </div>

</div>
